import Modal from './Modal';
import classes from './ModalCommonStyling.module.css';
import Input from '../Input'
import Button from '../Button';
import { useContext, useEffect, useState } from 'react';
import FileContext from '../../store/file-context'
import useServer from '../../db/useServer';
import { UPLOAD_NEW_PROJECT } from '../../config';
import { toast } from 'react-toastify';

const CreateProjectModal = (props) => {

    const [projectName, setProjectName] = useState('')
    const [isProjectNameEmpty, setProjectNameEmpty] = useState(false)
    const { reset,  isLoading, error, handleAPICall} = useServer();

    const ctx = useContext(FileContext);


    function handleValueChange(e) {
        setProjectName(e.target.value);
        setProjectNameEmpty(e.target.value.trim().length === 0)
    }

    useEffect(() => {
        if(error) {
            toast.error("Something went wrong, try again after sometime!",error.message)
            reset();
        }

    }, [error, reset])

    const addProjectToServer = async () => {
        const result = await handleAPICall(UPLOAD_NEW_PROJECT, 'POST', {
            projectName: projectName
        });
        if (!result) {
            return;
        }
        const newProjectId = result.data?._id || result._id;
        ctx.addNewProject({
            _id: newProjectId,
            projectName: projectName
        });
        props.removeBackdrop();
        ctx.selectedFilesFun(newProjectId);
    };

    const handleBtnClick = () => {
        if (projectName.trim() === '') {
            setProjectNameEmpty(true)
            return;
        }
        addProjectToServer();


    }
    const inputData = {
        input: {
            name: 'Project Name',
            type: "text",
            placeholder: ' ',
            value: projectName,
            onChange: handleValueChange,
        }
    }


    return (
        <Modal removeBackdrop={props.removeBackdrop} title="Create New Project">
            <p className={classes.p}>Create projects to categorize your files like folders just like you'd arrange documents in different folders on your desk. Separate your files for quick access and easy organization.</p>
            <Input input={inputData.input} />
            {isProjectNameEmpty && <p className={classes.error}>Project Name Cannot be Empty</p>}
            {isLoading && <p className={classes.info}>Creating new project for you, please wait...</p>}
            <div className={classes.btnDiv}>
                <Button onClick={() => { props.removeBackdrop() }} disabled={isLoading} className={`${classes.btn} ${classes.cancelBtn}`}> Cancel</Button>
                <Button onClick={handleBtnClick} disabled={isLoading} className={classes.btn}> Create</Button>
            </div>
        </Modal>
    )

}

export default CreateProjectModal;